export const SET_OPTION_TYPE = "SET_OPTION_TYPE";
export const SET_VIDEO_COMPONENT_TIME = "SET_VIDEO_COMPONENT_TIME";
export const SET_VIDEO_CURRENT_TIME = "SET_VIDEO_CURRENT_TIME";
export const SET_VIDEO_DETAILS_FOR_TIME = "SET_VIDEO_DETAILS_FOR_TIME";
export const SET_RELATED_VIDEO = "SET_RELATED_VIDEO";
export const SET_BOOKMARK_QUESTIONS_LIST = "SET_BOOKMARK_QUESTIONS_LIST";
export const REMOVE_BOOKMARK_DATA = "REMOVE_BOOKMARK_DATA";
